import {useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toggle} from 'opticks/lib/optimizely'

import {userAuthenticationSuccess} from '../modules/actions'
import {parseUserTokenFromCallbackUrl} from '../modules/thunks'
import {useAuth} from './AuthProvider'
import {selectIsLoading} from '../modules/selectors'
import {AuthContextType} from '../types/Auth'
import {useAuthConnection, UseCognitoType} from '../modules/useCognito'

const useToggleAuth = () => {
  const auth0Values = useAuth()
  const isLoading = useSelector(selectIsLoading)
  const authConnection = useAuthConnection()

  return toggle('f54ef0b3-cognito-auth', auth0Values, {
    isLoading,
    authConnection
  }) as
    | Partial<AuthContextType>
    | Pick<UseCognitoType, 'isLoading' | 'authConnection'>
}

const PasswordlessLoginHandler = () => {
  const dispatch = useDispatch()
  const {isLoading, authConnection} = useToggleAuth()

  useEffect(() => {
    if (!isLoading) {
      const authenticateUser = async () => {
        const callbackUrlPayload = await dispatch(
          parseUserTokenFromCallbackUrl(authConnection)
        )
        // @ts-expect-error
        const user = callbackUrlPayload?.payload

        dispatch(userAuthenticationSuccess(user, 'MagicLink'))
      }

      void authenticateUser()
    }
  }, [isLoading, dispatch])

  return null
}

export default PasswordlessLoginHandler
